import React from "react";
import KoChat from "shared/chat";
import KoContacts from "shared/contacts";

import styles from "./chat.module.scss";
import { useSelector } from "react-redux";
import { KoEmpty } from "packages";

function Chats() {
  let recipient = useSelector((state) => state.chatUser.recipient);
  console.log('recipient1', recipient);
  return (
    <div className={styles.manwrapper}>
      <KoContacts/>
      {recipient ? <KoChat recipient={recipient}/> : <KoEmpty title="Select a user to start a conversation"/>}
    </div>
  );
}

export default Chats;
